import { render, staticRenderFns } from "./AllDistroOrders.vue?vue&type=template&id=022401cd&scoped=true"
import script from "./AllDistroOrders.vue?vue&type=script&lang=js"
export * from "./AllDistroOrders.vue?vue&type=script&lang=js"
import style0 from "./AllDistroOrders.vue?vue&type=style&index=0&id=022401cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022401cd",
  null
  
)

export default component.exports